import { AxiosError } from "axios";

export const isStaleApiCredentialError = (error: unknown) => {
  const axiosError = error as AxiosError<any>;
  if (axiosError.response?.status !== 401) {
    return false;
  }

  const responseData = axiosError.response?.data;
  const message =
    typeof responseData === "string"
      ? responseData
      : responseData?.error || responseData?.message;
  const normalizedMessage = String(message || "").toLowerCase();

  return (
    normalizedMessage.includes("invalid_token") ||
    normalizedMessage.includes("account address required") ||
    normalizedMessage.includes("unauthorized")
  );
};
